module.exports = __webpack_public_path__ + "static/media/backgroundanim.46969975.gif";